<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2 mt-3" @click="$router.go(-1)">
        <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
      </b-button>

      <b-container style="max-width: 90%; margin: auto;">
        <b-row>
          <b-col md="12" class="mt-4 mb-4">
            <div class="divisor">
              {{ $t('crear_nueva_region') }}
            </div>
          </b-col>
        </b-row>

        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="4">
              <b-form-group label-for="nombre">
                <template v-slot:label>
                  {{ $t('nombre') }} <span class="text-danger">*</span>
                </template>
                <b-form-input id="nombre" v-model="form.nombre" required
                  placeholder="Nombre de la región"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="numero">
                <template v-slot:label>
                  {{ $t('numero') }}
                </template>
                <b-form-input id="numero" type="number" v-model.number="form.numero"
                  placeholder="Número de la región"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="idPais">
                <template v-slot:label>
                  {{ $t('pais') }} <span class="text-danger">*</span>
                </template>
                <b-form-select id="idPais" v-model="form.idPais" required>
                  <option :value="null" disabled>{{ $t('seleccione_pais') }}</option>
                  <option v-for="option in opcionesPaises" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button type="submit" variant="primary">
            {{ $t('guardar') }}
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import regionService from '@/api/regionService';
import Swal from 'sweetalert2';

export default {
  name: 'RegionCrear',
  data() {
    return {
      form: {
        nombre: '',
        numero: null,
        idPais: null,
      },
      opcionesPaises: [],
    };
  },
  async beforeMount() {
    this.opcionesPaises = (await regionService.getPaisesOptions())
      .sort((a, b) => String(a.text || '').localeCompare(String(b.text || ''), 'es', { sensitivity: 'base' }));

    const pais = this.$route.query.pais;
    if (pais !== undefined && pais !== null && pais !== '') {
      const match = this.opcionesPaises.find(o => String(o.value) === String(pais));
      this.form.idPais = match ? match.value : pais;
    }
  },
  methods: {
    async submitForm() {
      Swal.fire({
        title: this.$t('esta_seguro'),
        text: this.$t('revisa_datos'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Crear',
        cancelButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (!result.isConfirmed) {
          Swal.close();
          return;
        }

        try {
          Swal.fire({
            html: '<div style="display:flex;align-items:center;justify-content:center;">' +
                  '<img src="/img/others/loading.gif" alt="Loading" style="width:50px;height:50px;margin-right:15px;">' +
                  '<div><h3 style="color:#006393;">' + this.$t('creando') + '</h3></div>' +
                  '</div>',
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          const response = await regionService.create(this.form);

          if (!response || !response.data) {
            Swal.fire({ icon: 'error', title: 'Oops...', text: 'Ocurrió un error desconocido.' });
            return;
          }

          Swal.fire({
            title: this.$t('creado_correctamente'),
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          });

          this.$router.push({ name: 'regiones' });
        } catch (error) {
          let status = 0;
          if (error && error.response && typeof error.response.status !== 'undefined') {
            status = error.response.status;
          }

          const raw = (error && error.response) ? error.response.data : error;
          let msg = 'Ocurrió un error al crear la región.';
          if (typeof raw === 'string') {
            msg = raw;
          } else if (raw && (raw.message || raw.Message || raw.error || raw.title || raw.detail)) {
            msg = String(raw.message || raw.Message || raw.error || raw.title || raw.detail);
          } else if (error && error.message) {
            msg = error.message;
          }

          const title = (status === 409) ? this.$t('region_ya_existe') :
                        (status === 400) ? this.$t('datos_invalidos') : 'Oops...';
          const icon = (status === 409 || status === 400) ? 'warning' : 'error';

          Swal.fire({
            icon: icon,
            title: title,
            html: '<pre style="font-family: inherit;text-align:center;white-space:pre-wrap;margin:0">' + msg + '</pre>',
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.divisor {
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  padding: 15px;
  background: #6172e9;
  border-radius: 10px;
}
</style>
